import React from 'react'
import { Route } from 'react-router'

const OutlookRedirectView = React.lazy(() => import('@/modules/redirect/outlook-redirect-view'))
const outlookRedirectRoutes = (
  <>
    <Route path='redirect/outlook' Component={OutlookRedirectView} />
  </>
)

export default outlookRedirectRoutes
